import React, { useState } from "react";
import Student from './student';
import { FlexSlider } from "../../components/flexslider";
import { Container } from 'react-bootstrap';

import "./style.scss";
const hoverList = [null,0,1,2,5,4,3,6,7,8,null,Math.floor(Math.random() * 9)];

export const Students = props => {

    const [state, setState] = useState({ rnd: Math.random(), intervalsArr: [] });
    const [hover, setHover] = useState([]);

    function showRnd(i) {
        if (Utils.isMobile()) {
            if (hover[i] && hover[i][0] < 8) hover[i][0] = hover[i][0] + 1;
            else hover[i] = [0];
        } else {
            if (!hover[i]) hover[i] = [...hoverList];
            if (hover[i].length > 1) {
                hover[i].shift();
            } else {
                let rnd;
                while(!rnd || rnd === hover[i]) {
                    rnd = Math.floor(Math.random() * 9);
                }
                hover[i] = [rnd];
            }
        }
        setHover(hover);
        setState(prevState => ({ ...prevState, rnd: state.rnd++ }))
      }
    function startInterval(i) {
        if (state.intervalsArr[i] === 'all') return;
        students.forEach((interval, index) => {
            if (i === index) {
                if (!state.intervalsArr[i]) {
                    state.intervalsArr[i] = setInterval(() => showRnd(i), 6000);
                    setState(prevState => ({ ...prevState, intervalsArr: state.intervalsArr }));
                }
            } else {
                stopInterval(index);
            }
        });
      }

    function stopInterval(i, status) {
        clearInterval(state.intervalsArr[i]);
        state.intervalsArr[i] = status;
        setState(prevState => ({ ...prevState, intervalsArr: state.intervalsArr }));
    }

    function stopAll() {
        state.intervalsArr.forEach((interval, index) => {            
            stopInterval(index, 'all');
        });
        setHover([]);
    }

    let students = [];
    students = [...props.data];

    function findStart() {
        let alias = Utils.getParams('alias').alias;
        let index = props.data.findIndex(x => x.title === alias);
        if (index === -1) return 0;
        return index;
    };
    
    return (
        <Container className={`students ${props.language}`}>
            <div className="title">{props.title}</div>
            <FlexSlider
                id={'students_fs'}
                after={(slider) => {
                    var n = slider.currentSlide === 0 ? students.length -1 : slider.currentSlide - 1;
                    startInterval(slider.currentSlide);
                    Utils.updateUrlString(false, {alias: students[slider.currentSlide].title});
                }}
                init={() => startInterval(findStart())}
                startAt={findStart()}
                rtl={props.language === 'he'}
                items={props.data.map((student, i) => 
                    <Student 
                        key={i} 
                        index={i} 
                        {...props} 
                        student={student} 
                        hover={(hover[i] ? hover[i][0] : null)} 
                        stopRnd={stopAll} 
                    />
                )}/>
        </Container>
    );
};
